import fetch from "node-fetch";

export default class {
  async getTeamDetails({ id }) {
    const res = await fetch(`${process.env.CMS_URL}/teams/${id}`);
    if (res.ok) {
      return res.json();
    }
    throw new Error(res.statusText);
  }

  async getSponsors({ id }) {
    const res = await fetch(`${process.env.CMS_URL}/teams/${id}/sponsors`);
    if (res.ok) {
      return res.json();
    }
    throw new Error(res.statusText);
  }

  async getPlayers({ id, competitionId }) {
    const res = await fetch(
      `${process.env.API_URL}/teams/${id}/players?competitionTypeId=${competitionId}`,
      { headers: { "x-version": 2 } }
    );
    if (res.ok) {
      return res.json();
    }
    throw new Error(res.statusText);
  }
}
